import React from "react"
import {
  Box,
  chakra,
  Container,
  Stack,
  Text,
  useColorModeValue,
  VisuallyHidden,
} from "@chakra-ui/react"
import { FaInstagram, FaTwitter, FaYoutube, FaLinkedin } from "react-icons/fa"
import { ReactNode } from "react"
import { useStaticQuery, graphql } from "gatsby"

const SocialButton = ({
  children,
  label,
  href,
}: {
  children: ReactNode
  label: string
  href: string
}) => {
  return (
    <chakra.button
      bg={useColorModeValue("blackAlpha.100", "whiteAlpha.100")}
      rounded={"full"}
      w={8}
      h={8}
      cursor={"pointer"}
      as={"a"}
      href={href}
      display={"inline-flex"}
      alignItems={"center"}
      justifyContent={"center"}
      transition={"background 0.3s ease"}
      _hover={{
        bg: useColorModeValue("blackAlpha.200", "whiteAlpha.200"),
      }}
    >
      <VisuallyHidden>{label}</VisuallyHidden>
      {children}
    </chakra.button>
  )
}

export default function Footer() {
  const buildDate = useStaticQuery(graphql`
    query {
      currentBuildDate {
        currentDate
      }
    }
  `)
  const date = buildDate.currentBuildDate.currentDate

  return (
    <Box
      bg={useColorModeValue("purple.900", "gray.900")}
      color={useColorModeValue("gray.200", "gray.200")}
    >
      <Container
        as={Stack}
        maxW={"7xl"}
        py={4}
        direction={{ base: "column", md: "row" }}
        spacing={4}
        justify={{ base: "center", md: "space-between" }}
        align={{ base: "center", md: "center" }}
      >
        {process.env.GATSBY_ENV === "dev" ? (
          <Text>© 2025 FlexPlum. All rights reserved. v: {date} </Text>
        ) : (
          <Text>© 2025 FlexPlum. All rights reserved.</Text>
        )}

        <Stack direction={"row"} spacing={6}>
          <SocialButton
            label={"LinkedIn"}
            href={"https://www.linkedin.com/company/flexplum/"}
          >
            <FaLinkedin />
          </SocialButton>
          {/* <SocialButton
            label={"YouTube"}
            href={"https://www.linkedin.com/company/flexplum/"}
          >
            <FaYoutube />
          </SocialButton>
          <SocialButton
            label={"Instagram"}
            href={"https://www.linkedin.com/company/flexplum/"}
          >
            <FaInstagram />
          </SocialButton> */}
        </Stack>
      </Container>
    </Box>
  )
}
